<template>
    <div class="srv-accueil">
        <header class="srv-head">
            <div class="srv-avatar">{{ initiales }}</div>
            <div>
                <div class="srv-head-titre">{{ historique ? 'Mes commandes' : 'Bonjour, ' + serveur.name }}</div>
                <div class="srv-head-sous">Service du {{ dateDuJour }}</div>
            </div>
            <span class="srv-head-sp"></span>
        </header>

        <div class="srv-corps">
            <!-- Trois chiffres, et pas un de plus : c'est ce que le serveur
                 regarde entre deux tables. -->
            <div v-if="!historique" class="srv-stats">
                <div class="srv-stat">
                    <span class="srv-stat-lbl">Commandes</span>
                    <span class="srv-stat-val srv-num">{{ commandes.length }}</span>
                </div>
                <div class="srv-stat">
                    <span class="srv-stat-lbl">Total</span>
                    <span class="srv-stat-val srv-num accent">{{ fmt(total) }}</span>
                </div>
                <div class="srv-stat">
                    <span class="srv-stat-lbl">Encaissé par moi</span>
                    <span class="srv-stat-val srv-num ok">{{ fmt(totalMoi) }}</span>
                </div>
            </div>

            <div class="srv-filtres">
                <button v-for="f in filtres" :key="f.cle"
                        class="srv-filtre" :class="{ active: filtre === f.cle }"
                        @click="filtre = f.cle">
                    {{ f.libelle }}
                </button>
            </div>

            <div v-if="!visibles.length" class="srv-vide">
                <i class="ri-inbox-line"></i>
                <p>Aucune commande</p>
                <small>{{ filtre === 'toutes' ? 'Ouvrez une table pour commencer.' : 'Rien dans ce filtre.' }}</small>
            </div>

            <button v-for="c in visibles" :key="c.id" class="srv-cmd" @click="$emit('ouvrir', c)">
                <div class="srv-cmd-l1">
                    <span class="srv-cmd-table">{{ c.table ? c.table.name : 'Sans table' }}</span>
                    <!-- Plusieurs clients peuvent partager une table : le libellé
                         client distingue les additions. -->
                    <span v-if="labelClient(c)" class="srv-cmd-client">{{ labelClient(c) }}</span>
                    <span class="srv-cmd-num srv-num">{{ c.numero }}</span>
                    <span class="srv-cmd-mtnt srv-num">{{ fmt(totalCommande(c)) }}</span>
                </div>
                <div class="srv-cmd-l2">
                    <span class="srv-cmd-meta">
                        {{ nbArticles(c) }} article{{ nbArticles(c) > 1 ? 's' : '' }} · {{ depuis(c.creeeLe) }}
                    </span>
                    <span class="srv-pill" :class="'srv-pill-' + STATUTS[c.statut].ton">
                        {{ STATUTS[c.statut].libelle }}
                    </span>
                </div>
            </button>
        </div>

        <div v-if="!historique" class="srv-fab-zone">
            <button class="srv-btn srv-fab" @click="$emit('nouvelle')">
                <i class="ri-add-line"></i>
                <span>Nouvelle commande</span>
            </button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt } from "../menu/format";
    import { STATUTS, estEnCours, labelClient } from "./statuts";

    export default {
        name: "srvaccueil",
        props: {
            serveur: { type: Object, required: true },
            commandes: { type: Array, default: () => [] },
            historique: { type: Boolean, default: false },
        },
        emits: ["nouvelle", "ouvrir"],
        data: () => ({
            STATUTS,
            filtre: "toutes",
            filtres: [
                { cle: "toutes", libelle: "Toutes" },
                { cle: "encours", libelle: "En cours" },
                { cle: "reglees", libelle: "Réglées" },
            ],
        }),
        computed: {
            initiales() {
                // La base ne sépare pas nom et prénom : `representant` est un
                // seul champ. On prend donc les initiales des deux premiers mots.
                return String(this.serveur.name || "")
                    .split(/\s+/).filter(Boolean).slice(0, 2)
                    .map((m) => m[0]).join("").toUpperCase();
            },
            dateDuJour() {
                return new Date().toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
            },
            visibles() {
                if (this.filtre === "encours") return this.commandes.filter((c) => estEnCours(c.statut));
                if (this.filtre === "reglees") return this.commandes.filter((c) => !estEnCours(c.statut));
                return this.commandes;
            },
            total() {
                return this.commandes.reduce((s, c) => s + this.totalCommande(c), 0);
            },
            totalMoi() {
                return this.commandes.filter((c) => c.statut === "moi")
                    .reduce((s, c) => s + this.totalCommande(c), 0);
            },
        },
        methods: {
            fmt,
            labelClient,
            totalCommande(c) { return c.lignes.reduce((s, l) => s + l.pu * l.qte, 0); },
            nbArticles(c) { return c.lignes.reduce((s, l) => s + l.qte, 0); },
            // Repère temporel relatif : « il y a 12 min » se lit plus vite
            // qu'une heure absolue quand on gère six tables de front.
            depuis(ts) {
                const min = Math.max(0, Math.round((Date.now() - ts) / 60000));
                if (min < 1) return "à l'instant";
                if (min < 60) return "il y a " + min + " min";
                const h = Math.floor(min / 60);
                return "il y a " + h + " h " + String(min % 60).padStart(2, "0");
            },
        },
    };
</script>

<style scoped>
    .srv-accueil { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-avatar {
        width: 38px; height: 38px; border-radius: var(--srv-r-full);
        display: flex; align-items: center; justify-content: center;
        background: var(--srv-primary); color: var(--srv-on-primary);
        font-size: 14px; font-weight: 800; text-transform: uppercase; flex-shrink: 0;
    }

    .srv-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--srv-sm); margin-bottom: var(--srv-md); }
    .srv-stat {
        display: flex; flex-direction: column; gap: 4px; padding: 10px;
        background: var(--srv-surface); border: 1px solid var(--srv-outline-variant);
        border-radius: var(--srv-r); min-width: 0;
    }
    .srv-stat-lbl {
        font-size: 10px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase;
        color: var(--srv-on-variant); line-height: 1.2;
    }
    .srv-stat-val { font-size: 15px; font-weight: 800; overflow-wrap: anywhere; }
    .srv-stat-val.accent { color: var(--srv-primary); }
    .srv-stat-val.ok { color: var(--srv-success); }

    .srv-filtres { display: flex; gap: var(--srv-sm); margin-bottom: var(--srv-md); overflow-x: auto; }
    .srv-filtre {
        flex-shrink: 0; min-height: 40px; padding: 0 16px;
        background: var(--srv-surface-high); color: var(--srv-on-variant);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r-chip);
        font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer;
    }
    .srv-filtre.active { background: var(--srv-primary); color: var(--srv-on-primary); border-color: var(--srv-primary); }

    .srv-cmd {
        display: block; width: 100%; text-align: left; cursor: pointer;
        margin-bottom: var(--srv-sm); padding: 14px;
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-family: inherit;
    }
    .srv-cmd:hover { border-color: var(--srv-outline); }

    .srv-cmd-l1 { display: flex; align-items: center; gap: var(--srv-sm); }
    .srv-cmd-table { font-size: 16px; font-weight: 700; }
    .srv-cmd-num {
        padding: 2px 8px; border-radius: var(--srv-r-chip);
        background: var(--srv-surface-highest); color: var(--srv-on-variant);
        font-size: 11px; font-weight: 700; white-space: nowrap;
    }
    .srv-cmd-client {
        padding: 2px 8px; border-radius: var(--srv-r-chip);
        background: var(--srv-primary-soft); color: var(--srv-primary);
        font-size: 11px; font-weight: 800; white-space: nowrap;
    }
    .srv-cmd-mtnt { margin-left: auto; font-size: 16px; font-weight: 800; white-space: nowrap; }

    .srv-cmd-l2 {
        display: flex; align-items: center; justify-content: space-between;
        gap: var(--srv-sm); margin-top: var(--srv-sm);
    }
    .srv-cmd-meta { font-size: 13px; color: var(--srv-on-variant); }

    /* Le bouton reste au-dessus des onglets, dans la zone du pouce. */
    .srv-fab-zone {
        position: fixed; bottom: 60px; left: 50%; transform: translateX(-50%);
        width: 100%; max-width: 480px; z-index: 56;
        padding: var(--srv-sm) var(--srv-gutter);
        background: linear-gradient(to top, var(--srv-bg) 60%, transparent);
        pointer-events: none;
    }
    .srv-fab { pointer-events: auto; }
</style>
